import * as Yup from "yup";

export const farmerPartnerSchema = Yup.object({
  clientId: Yup.string().required("Client Id is required"),
  farmPartnerName: Yup.string().required("Farmer Partner Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  contactNumber: Yup.string()
    .required("Contact Number is required")
    .matches(/^[0-9]{10}$/, "Contact Number must be exactly 10 digits"),
  latitude: Yup.number().nullable(),
  longitude: Yup.number().nullable(),
  serviceRadiusKm: Yup.number().nullable(),
  pincode: Yup.string().matches(/^[0-9]{6}$/, "Invalid pincode"),
});
